import api from "../services/api";

export const uploadSpecialtyCakeImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const { data } = await api.post(
      "/services/upload-specialty-cake-image",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return data.fileUrl;
  } catch (error) {
    console.error("Error uploading to S3:", error);
    throw error;
  }
};

export const uploadFlavorImageToS3 = async (file, flavorName, type) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("flavorName", flavorName);
    formData.append("type", type); // "primary" or "secondary"

    const response = await api.post("/services/upload-flavor-image", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data[0];
  } catch (error) {
    console.error("Error uploading to S3:", error);
    throw error;
  }
};

export const uploadCheesecakeFlavorImageToS3 = async (
  file,
  flavorName,
  type
) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("flavorName", flavorName);
    formData.append("type", type); // "primary" or "secondary"

    const response = await api.post(
      "/services/upload-cheesecake-flavor-image",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return response.data[0];
  } catch (error) {
    console.error("Error uploading to S3:", error);
    throw error;
  }
};

export const uploadPatisserieImageToS3 = async (file, flavorName, type) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("flavorName", flavorName);
    formData.append("type", type); // "regular" or "wedding"

    const response = await api.post(
      "/services/upload-patisserie-image",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return response.data[0];
  } catch (error) {
    console.error("Error uploading to S3:", error);
    throw error;
  }
};

export const uploadPrimaryImage = async (file, sessionId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("sessionId", sessionId);

  const res = await api.post("/uploads/upload-primary-image", formData);

  // if (!res.ok) {
  //   throw new Error("Upload failed");
  // }

  return { url: res.data.fileUrl };
};

export const uploadReferenceImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await api.post("/uploads/upload-reference-image", formData);
  return res.data; // { url }
};
